import { ReportSdk } from 'lib-klab-sdks';
import {
    KeystrokeReportItem,
    KeystrokeReportResponse,
} from '../../../domain/models/reports/keystroke-report.model';

export function mapSdkKeystrokeItemToDomain(item: ReportSdk.KeystrokeItem): KeystrokeReportItem {
    return {
        activityEventId: item.activityEventId ?? 0,
        workSessionId: item.workSessionId ?? '',
        sourceType: item.sourceType ?? 'APP',
        displayName: item.displayName ?? '-',
        keySequence: item.keySequence ?? '',
        keyCount: item.keyCount ?? 0,
        mouseClicks: item.mouseClicks ?? 0,
        startedAt: item.startedAt ?? '',
        endedAt: item.endedAt ?? '',
    };
}

export function mapSdkKeystrokeReportToDomain(
    response: ReportSdk.KeystrokeReportResponse | null | undefined,
): KeystrokeReportResponse {
    return {
        employeeId: response?.employeeId ?? 0,
        startDate: response?.startDate ?? '',
        endDate: response?.endDate ?? '',
        content: (response?.content ?? []).map(mapSdkKeystrokeItemToDomain),
        page: {
            page: response?.page?.page ?? 0,
            size: response?.page?.size ?? 10,
            totalElements: response?.page?.totalElements ?? 0,
            totalPages: response?.page?.totalPages ?? 1,
        },
    };
}

